<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import Footer from '@/components/Footer/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';

import { masterComputed, masterMethods } from '@/state/helpers';
import { checkPermission } from '@/utils/handlers';
import { keyMaster } from '@/config/constants';
import { maxLength, required } from 'vuelidate/lib/validators';
import { showMessage } from '@/utils/messages';
import { InputRadio } from '@/components/Input';
// InputCheckBox
export default {
    page: {
        title: '規約用条件設定',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        Multiselect,
        Footer,
        LoadingIcon,
        InputRadio
        // InputCheckBox
    },
    data() {
        return {
            ruleClose: null,
            ruleOpen: null,
            listDataMasterCampaignTypeClose: [],
            listDataMasterCampaignTypeOpen: [],
            form: {
                rule: '',
                type: '',
                platforms: [],
                is_default: 0
            },
            listType: [
                { id: 1, name: '共通' },
                { id: 2, name: 'クローズ' },
                { id: 3, name: '応募種別' }
            ],
            submitted: false,
            isLoading: false
        };
    },
    validations: {
        form: {
            rule: { required, maxLength: maxLength(255) },
            type: { required }
        }
    },
    computed: {
        ...masterComputed
    },
    async mounted() {
        await this.getListMasterCampaignType();
        await this.getListMaster();
        this.getDetail();
    },
    methods: {
        checkPermission,
        ...masterMethods,
        getDetail() {
            if (this.$route.query.id) {
                let data = {
                    id: this.$route.query.id
                };
                this.isLoading = true;
                this.detailMasterRule1(data).then((data) => {
                    if (data.code == 200) {
                        this.form = data.data;
                        this.form.platforms.forEach((item) => {
                            let indexClose = this.listDataMasterCampaignTypeClose.findIndex((x) => x.id == item.id);
                            if (indexClose >= 0) this.ruleClose = item;
                            let indexOpen = this.listDataMasterCampaignTypeOpen.findIndex((x) => x.id == item.id);
                            if (indexOpen >= 0) this.ruleOpen = item;
                        });
                    }
                    this.isLoading = false;
                });
            }
        },

        getListMasterCampaignType() {
            return this.listMaster(keyMaster['campaign.type']).then((data) => {
                data.forEach((item) => {
                    if (item.value == 'クローズ') {
                        this.listDataMasterCampaignTypeClose = item.data.filter((x) => x.id != 723 && x.id != 764 && x.id != 793);
                    } else {
                        this.listDataMasterCampaignTypeOpen = item.data.filter((x) => x.id != 995 && x.id != 1180);
                    }
                });
            });
        },
        getListMaster() {
            return this.getAllMasterRule().then((data) => {
                if (data.code == 200) {
                    data.data.forEach((item) => {
                        item.detail = item.detail.replace(/<\/?[^>]+(>|$)/g, '');
                    });
                }
            });
        },
        goEdit() {
            this.$router.push({ path: '/master/condition-rule' });
        },
        formSubmit() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            } else {
                this.register();
            }
        },
        register() {
            let data = JSON.parse(JSON.stringify(this.form));
            data.platforms = [];
            if (this.ruleOpen && this.ruleOpen?.id) {
                data.platforms.push(this.ruleOpen.id);
            }
            if (this.ruleClose && this.ruleClose?.id) {
                data.platforms.push(this.ruleClose.id);
            }
            if (this.$route.query.id) {
                this.updateMasterRuleDetail1(data).then((data) => {
                    if (data.code == 200) {
                        showMessage(data.code, this.$bvToast, '保存されました。');
                        this.getDetail();
                    }

                    if (data.code == 422) {
                        showMessage(data.code, this.$bvToast, this.$t(data.message));
                    }
                });
            } else {
                this.createMasterRuleDetail1(data).then((data) => {
                    if (data.code == 200) {
                        this.$router
                            .push({
                                path: '/master/condition-rule-edit',
                                query: {
                                    id: data.data.id
                                }
                            })
                            .then(() => {
                                showMessage(data.code, this.$bvToast, '登録されました。');
                                this.getDetail();
                            });
                    }

                    if (data.code == 422) {
                        showMessage(data.code, this.$bvToast, this.$t(data.message));
                    }
                });
            }
        }
    }
};
</script>

<template>
    <Layout>
        <div v-if="!isLoading">
            <div class="col-lg-12">
                <div class="card" style="min-height: 100vh">
                    <div class="card-body">
                        <form class="needs-validation" @submit.prevent="formSubmit" autocomplete="off">
                            <div class="row form-group">
                                <label for="" class="col-sm-3">タイトル<span class="text-danger">*</span></label>
                                <div class="col-sm-9">
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="form.rule"
                                        :class="{
                                            'is-invalid': submitted && $v.form.rule.$error
                                        }"
                                    />
                                    <div v-if="submitted && $v.form.rule.$error" class="invalid-feedback">
                                        <span v-if="!$v.form.rule.required">{{
                                            $t('validateField.required', {
                                                field: 'タイトル'
                                            })
                                        }}</span>
                                        <span v-if="!$v.form.rule.maxLength">
                                            {{
                                                $t('validateField.max255', {
                                                    field: 'タイトル'
                                                })
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label for="" class="col-sm-3">種別<span class="text-danger">*</span></label>
                                <div class="col-sm-9">
                                    <div
                                        class="d-flex flex-wrap"
                                        :class="{
                                            'is-invalid': submitted && $v.form.type.$error
                                        }"
                                    >
                                        <div v-for="item in listType" :key="item.id + 's'">
                                            <InputRadio
                                                class="mr-4 mb-1"
                                                :model.sync="form.type"
                                                :id="`tool${item.id}`"
                                                :value="item.id"
                                                :label="item.name"
                                            />
                                        </div>
                                    </div>
                                    <div v-if="submitted && $v.form.type.$error" class="invalid-feedback">
                                        <span v-if="!$v.form.type.required">{{
                                            $t('validateField.required', {
                                                field: '種別'
                                            })
                                        }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="row form-group" v-if="form.type == 3">
                                <label for="" class="col-sm-3">クローズ</label>
                                <div class="col-sm-9">
                                    <Multiselect
                                        :id="`select-ruleClose-default`"
                                        :value.sync="ruleClose"
                                        :options="listDataMasterCampaignTypeClose"
                                        :config="{
                                            trackBy: 'id',
                                            label: 'value',
                                            error: false,
                                            isRemove: false
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="row form-group" v-if="form.type == 3">
                                <label for="" class="col-sm-3">オープン</label>
                                <div class="col-sm-9">
                                    <Multiselect
                                        :id="`select-ruleOpen-default`"
                                        :value.sync="ruleOpen"
                                        :options="listDataMasterCampaignTypeOpen"
                                        :config="{
                                            trackBy: 'id',
                                            label: 'value',
                                            error: false,
                                            isRemove: false
                                        }"
                                    />
                                </div>
                            </div>

                            <!-- <div class="row form-group">
                                <label for="" class="col-sm-3">デフォルト</label>
                                <div class="col-sm-9">
                                    <div class="d-flex flex-wrap">
                                        <InputCheckBox class="mr-4 mb-1" :model.sync="form.is_default" :value="1" :label="''" />
                                    </div>
                                </div>
                            </div> -->
                        </form>
                    </div>
                </div>
            </div>
            <Footer>
                <div class="d-flex justify-content-center">
                    <button type="button" @click="goEdit()" class="btn btn-common-footer mr-2">キャンセル</button>
                    <button v-if="$route.query.id" type="submit" @click="formSubmit()" class="btn btn-common btn-success">保存</button>
                    <button v-else type="submit" @click="formSubmit()" class="btn btn-common btn-primary">
                        <i class="ri-file-add-line"></i>登録
                    </button>
                </div>
            </Footer>
        </div>
        <div class="d-flex justify-content-center" v-else>
            <LoadingIcon />
        </div>
    </Layout>
</template>
<style>
.box-select2 .multiselect__input,
.box-select2 .multiselect__single {
    width: 98% !important;
}
</style>
